import {createSlice} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import ICommonOptions from "../../types/commonOptions";

export type TCommonState = {
    success: string | string[] | null
    error: string | string[] | null
    options: ICommonOptions
}

const optionsDefault = {
    revisionsStep: 10,
    revisionsFilterPeriod: 'lastMonth',
    revisionsFilterValue: 0,
    revisionsFilterMonthValue: 0,
    tracingFilterEmail: '',
    tracingSortingField: '',
    tracingSortingType: 'ASC',
    logsSortingField: '',
    logsSortingType: 'ASC',
    logsFilterTag: '',
    logsFilterDateFrom: '',
    logsFilterDateTo: ''
}

const localStorageOptions = JSON.parse(localStorage.getItem('_wp_options') as string) || optionsDefault

const initialState: TCommonState = {
    success: null,
    error: null,
    options: localStorageOptions
}

export const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setErrorAction: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload
        },
        setSuccessAction: (state, action: PayloadAction<string | null>) => {
            state.success = action.payload
        },
        resetAction: (state, action: PayloadAction<string | void>) => {
            state.success = null
            state.error = null
        },
        setOptionsAction: (state, action: PayloadAction<Partial<ICommonOptions>>) => {
            const options = {
                ...state.options,
                ...action.payload
            }
            localStorage.setItem('_wp_options', JSON.stringify(options))
            state.options = (options as ICommonOptions)
        },
    }
})

export const {setErrorAction, setSuccessAction, resetAction, setOptionsAction} = commonSlice.actions
export default commonSlice.reducer